import React from 'react'
import { Hero, MainHeading, Breadcrumb, PageHeaderIntro, FindAgent, CommonList, FigureCards, NewsCard, SuccessStories, CommonBlueCards, PlainText } from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';
import './educational-insurance.scss'

const EducationalInsurance = () => {

  const breadcrumbs = [
    { label: "Sentry Insurance home", link: "/" },
    { label: "Who we serve", link: "/whoweserve" },
    { label: "Service industry insurance", link: "/whoweserve/serviceindustries" },
    { label: "Educational insurance", link: "/whoweserve/serviceindustries/educational-insurance" },
  ];



  const HeaderData = [
    {
      para: 'We understand educating students is your number one priority. Your mission is more than a school, institution, or collection of buildings. While you’re working hard to provide an education and a safe place for students, we can be there to help protect you and your employees. When you work with us, we’ll take the time to get to know your organization and help provide you with the coverage that’s right for you.',
    },
  ]; 

  const Selectoptions = [
    { value: 'Constructions', label: 'Constructions' },
    { value: 'DealerShip', label: 'DealerShip' },
    { value: 'Manufacturing and process industries', label: 'Manufacturing and process industries' },
    { value: 'Retailers and Distributors', label: 'Retailers and Distributors' },
    { value: 'Service industries', label: 'Service industries' },
    { value: 'Trucking', label: 'Trucking' },
  ];

  const Datalist = [
    "Loss-sensitive workers’ compensation insurance coverage",
    "Dedicated and knowledgeable safety services professionals",
    "Powerful cost-control tools",
  ];

  const revenueData = [
    {
      id: 1,
      value: "8",
      unit: "Sentry leaders",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 2,
      value: "$1B+",
      unit: "Paid in claims",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
    {
      id: 3,
      value: "1992",
      unit: "First year",
      description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
    },
  ];

  const ProductCardData = [
    {
      id: 1,
      title: 'Physical damage insurance',
      description:
        'Weather, animals, other drivers—all things that can damage your vehicle. Let us help cover your costs with physical damage insurance.',
      linkUrl: '',
      linkText: 'More about physical damage insurance >',
    },
    {
      id: 2,
      title: 'Cyber liability insurance',
      description:
        'Data breaches. While we hope they never happen to your business, they are a potential risk. Help protect your company with cyber liability coverage.',
      linkUrl: '/',
      linkText: 'More about cyber liability insurance >',
    },
    {
      id: 3,
      title: 'General liability insurance',
      description:
        'We offer protection against liability claims for your business. Coverage options include product liability, product recall, and errors and omissions.',
      linkUrl: '/',
      linkText: 'More about general liability insurance >',
    },
  ];

  const ResourceData = [
    {
      id: 1,
      title: 'Construction resources',
      description:
        'Explore our resources featuring valuable tools, articles, and guides on topics related to insurance coverages, safety resources, and retirement strategies.',
      linkUrl: '',
      linkText: 'View resources >',
    },
    {
      id: 2,
      title: 'Workers’ compensation 101: A guide for employers',
      description:
        'Accidents happen. That’s why workers’ compensation is crucial—and in some states required—to help you protect your business and your employees. This helpful guide explains the complexities of workers’ compensation.',
      linkUrl: '/',
      linkText: 'View guide >',
    },
  ];

  const plaindata = [
    {
      heading: "When you have a claim, we’re here to help manage it—so you can keep focusing on your students.",
      text: "Nobody wants to experience them, but claims do happen. We’re proud to have our own in-house claims team, who can help take care of cost-containment, investigation, litigation, and any special instructions from you. We’re here to help handle your claim, so you can stay focused on your students and your organization.",
      linkText: "View resources",
      linkUrl: "/resources"
    },
  ]

  return (
    <>
      <div className='educational-insurance-main'>
        {/* hero section */}
        <Hero img={images["Teacher_talking.avif"]} />
        <Container>
          {/* Breadcrumb */}
          <Breadcrumb crumbs={breadcrumbs} />

          {/* heading  */}
          <MainHeading title="Insurance for educational institutions" showshare={true} />

          {/* page intro */}
          <PageHeaderIntro Data={HeaderData} showImage={false} />

          {/*common list section */}
          <CommonList Heading="We can offer educational institutions:" list={Datalist} />

          {/* heading text */}
          <PlainText data={plaindata} />

          {/* figure cards */}
          <FigureCards data={revenueData} heading={'Significant figures'} />

          {/* products cards */}
          <NewsCard Title="Products for your business" CardData={ProductCardData} showNavLink={false} subTitle="PRODUCTS" />

          {/* success stories */}
          <SuccessStories />

          {/* resorce data */}
          {/* <CommonBlueCards CardData={ResourceData} Title="Related resources or services" /> */}

          {/* find agent */}
          <FindAgent options={Selectoptions} />
        </Container>
      </div>
    </>
  )
}

export default EducationalInsurance;